import { FC } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import {ProfileApplyToViewContainer} from "../components/profile-apply-to-view.container";
import {ProfileApplyToEditContainer} from "../components/profile-apply-to-edit.container";
import { getItem } from "../../../shared/local-storage";

export const ProfileApplyTo: FC = () => {
  const applicantUserId = getItem("applicantUserId");

  return (
    <div>
      <Helmet>
        <title>Profile - Apply To</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ProfileApplyToViewContainer data={{ applicantId: applicantUserId }} />} />
        <Route path="edit/*" element={<ProfileApplyToEditContainer data={{ applicantId: applicantUserId }} />} />
      </Routes>
    </div>
  );
};
